@if ((client.isS || client.isM) && product.parent?.isConfigurable) {
<div class="pos-relative"
     [class.ng-hide]="!showOptions">
    @if (!$any(product)?.hasLetterOption) {
    <product-configurable-options-size class="form-size-1"
                                       [product]="product"
                                       [preselectOptions]="['color']"
                                       [preselectSingles]="true"
                                       [storage]="true"
                                       [sizeGuideVariant]="parentView.sizeGuideVariant"
                                       [parentView]="parentView"
                                       (init)="parentView.handleInitChange($event.data)"
                                       (selectionChange)="parentView.handleSelectionChange($event.data)"
                                       (sizeGuideClicked)="parentView.openSidebar('size-guide')"
                                       (dataChange)="handleDataChange($event.data)" />
    } @else {
    <product-configurable-options [product]="product"
                                  [preselectOptions]="['color']"
                                  [preselectSingles]="true"
                                  [storage]="true"
                                  [sizeGuideVariant]="parentView.sizeGuideVariant"
                                  (init)="parentView.handleInitChange($event.data)"
                                  (selectionChange)="parentView.handleSelectionChange($event.data)"
                                  (sizeGuideClicked)="parentView.openSidebar('size-guide')"
                                  (dataChange)="handleDataChange($event.data)" />
    }
</div>
}
<action class="w-12 button left m-b-2-s m-b-2-m"
        cy-basketAddButton
        [status]="status"
        [clickEvent]="'add-to-basket.clicked'"
        (click)="handleClick()">
    @if ((hasAttributeSize && !selection?.['size']) || (hasAttributeLetter && !selection?.['letter'])) {
    @if (hasAttributeSize && hasAttributeLetter) {
    {{'Select size & letter' | translate}}
    } @else if (hasAttributeSize && !hasAttributeLetter) {
    {{'Select size' | translate}}
    } @else if (!hasAttributeSize && hasAttributeLetter) {
    {{'Select letter' | translate}}
    }
    } @else {
    @if (!!(isSalable || product?.isConfigurable)) {
    @if (!status.busy) {
    <span class="pos-relative button__text"
          [attr.data-alt-text]="altText">
        {{'Add to bag' | translate}}
    </span>
    } @else {
    {{'Adding...' | translate}}
    }
    } @else {
    <div class="w-12 flex flex-middle flex-justify-center">
        <span>{{'Email me when back in stock' | translate}}</span>
        <i class="icon-email fs-9 m-t-1"
           aria-hidden="true"></i>
    </div>
    }
    }
</action>

<result class="block s2"
        [status]="status" />
@if (!(isSalable || maxQty<10) &&
     maxQty>0) {
    <p>{{'Only % available' | translate : maxQty}}</p>
    }
